import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import notifyReducer from 'react-redux-notify'
import user from './user'
import cookies from './cookies'
import global from './global'
import products from './products'
import loginHistory from './login-history'
import orders from './orders'
import checkout from './checkout'
import invoice from './invoice'
import cart from './cart'
import securityCode from './security-code'
import contact from './contact'
import admin from './admin'
import reverseProxy from './reverse-proxy'
import summary from './summary'

export default combineReducers({
  notifications: notifyReducer,
  form: formReducer,
  cookies,
  global,
  products,
  user,
  loginHistory,
  orders,
  checkout,
  invoice,
  cart,
  securityCode,
  contact,
  admin,
  reverseProxy,
  summary
})



// WEBPACK FOOTER //
// ./reducers/index.js